<template>
  <!-- 案件詳細 -->
  <div id="KenshinRequestDetail">
    <div id="item-contens">
      <div class="card-content margin-top printMargin printBreakInside">
        <span style="font-size:20px;">装置情報</span>
        <table>
          <tr><th>発注元企業名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.orderCompanyName}}</td></tr>
          <tr><th>希望出荷週</th><td>{{data.desiredShippingWeek | formatDate()}}～</td></tr>
          <tr><th>検査種類</th><td>{{data.inspectionKind | inspectionKindFilter(inspectionKindList)}}</td></tr>
          <tr><th>判定有無</th><td v-if="data.isJudgment">する</td><td v-else>しない</td></tr>
          <tr><th>配送先</th><td>{{data.shippingInfoList.length}}カ所</td></tr>
          <tr><th>台数</th><td>{{getTotalUnits()}}台</td></tr>
          <tr><th style="vertical-align:top;">備考</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><div class="indentionArea printIndentionArea">{{data.biko}}</div></td></tr>
          <tr><th>納品書</th><td v-if="data.deliverySlip">必要</td><td v-else>不要</td>
          <tr><th>デモ</th><td><b-checkbox style="width:26px;" value="true" disabled v-model="data.demo"/>デモ(トライアル)</td></tr>
          <tr v-if="!isPrint && data.reportFileList && data.reportFileList.length>0"><th>ダウンロードファイル<br>(マクロデータ,PDFファイル)</th></tr>
          <tr v-if="!isPrint && data.reportFileList && data.reportFileList.length>0"><th></th><td><div><ul>
            <li v-for="(file ,index) in data.reportFileList" class="reportFiles" :key="index">
              <a @click="downloadFile(file.path, file.fileId)" style="text-decoration: underline;"><b-icon icon="paperclip"/>{{file.name}}</a>
            </li>
          </ul></div></td></tr>
        </table>
      </div>
      <div class="card-content margin-top printMargin printBreakInside" v-for="(item, index) in data.shippingInfoList" :key="index">
        <span v-if="data.shippingInfoList.length>1" style="font-size:20px;">配送先情報{{index + 1}}</span>
        <span v-else style="font-size:20px;">配送先情報</span>
        <table>
          <tr><th>事業所名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{item.enterpriseName}}</td></tr>
          <tr><th>装置配送先</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span v-if="item.deviceDeliveryZip">〒</span>{{item.deviceDeliveryZip}} {{item.deviceDeliveryAddress}}</td></tr>
          <tr><th>装置配送先連絡先</th><td>{{item.phoneNumber}}</td></tr>
          <tr><th>装置配送先宛名</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{item.deviceDeliveryName}}</td></tr>
          <tr v-if="!isAccommodations&&!isScreening()"><th>診断結果</th><td><b-checkbox style="width:26px;" value="true" disabled v-model="item.resultDelivery"/>装置配送先と異なる住所に送付する。</td></tr>
          <tr v-if="!isAccommodations&&!isScreening()" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><th>診断結果送付先</th><td v-if="item.resultDelivery"><span>〒</span>{{item.resultDeliveryZip}} {{item.resultDeliveryAddress}}</td><td v-else><span>〒</span>{{item.deviceDeliveryZip}} {{item.deviceDeliveryAddress}}</td></tr>
          <tr v-if="!isAccommodations&&!isScreening()" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><th>診断結果送付先宛名</th><td v-if="item.resultDelivery">{{item.resultDeliveryName}}</td><td v-else>{{item.deviceDeliveryName}}</td></tr>
          <tr><th>台数</th><td>{{item.subjectList.length}}台</td></tr>
        </table>
        <table>
          <tr>
            <th>被験者リスト</th>
            <th class="th_no">No.</th>
            <th class="th_name">氏名</th>
            <th class="th_name">氏名（カナ）</th>
            <th class="th_birth">生年月日</th>
            <th class="th_gender">性別</th>
            <th class="th_id">社員番号</th>
          </tr>
          <template v-for="(member,rowNum) in item.subjectList">
            <tr :key="rowNum">
            <td/><td>{{('000' + (rowNum+1)).slice(-3)}}</td>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{member.name}}</td>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{member.namekana}}</td>
            <td>{{member.birthday | formatDate()}}</td>
            <td>{{member.gender}}</td>
            <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{member.employeeNumber}}</td>
          </tr>
          </template>
        </table>
      </div>
      <ReExaminationDetailPart :detailData="data"/>
      <CancelDetailPart :detailData="data"/>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import ReExaminationDetailPart from "./components/ReExaminationDetailPart.vue"
import CancelDetailPart from "./components/CancelDetailPart.vue"

export default {
  name: "KenshinRequestDetail",
  props: ["data","isAccommodations","isPrint"],
  methods: {
    getTotalUnits:function(){
      var units = 0
      for(var i=0; i<this.data.shippingInfoList.length;i++){
        units = units + this.data.shippingInfoList[i].subjectList.length
      }
      return units
    },
    isScreening: function(){
      var type = this.inspectionKindList.find(item => item.value == this.data.inspectionKind)
      if(type && type.label3.indexOf("スクリーニング") != -1){
        return true
      }
      return false
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );
    }
  },
  data() {
    let inspectionKindList = this.getChoiceList(choicesType.kenshinKind, true);
    return {
      inspectionKindList: inspectionKindList,
    };
  },
  filters: {
    inspectionKindFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    formatDate: function(val){
      if(!val) return ""
      return val.replace(/-/g, "/")
    },
  },
  components: {
    ReExaminationDetailPart,
    CancelDetailPart,
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}
.th_no,
.th_gender,
.th_id {
  width:100px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/common/KenshinRequestDetail.vue